import { Injectable } from '@angular/core'
import { HttpService, INew_TableAction, TableActionsService } from '@lla-platform/core/core-data-access'
import { Observable } from 'rxjs'
import {
  IAdminAnnouncementDetail,
  IAdminAnnouncementsResponse,
  IAnnouncementUsersResponse,
  IAnnouncementsResponse,
  ISendAnnouncementRequest,
  IUnreadAnnouncementsCountResponse
} from '../interfaces/announcement.interface'
import { ANNOUNCEMENTS_API_URL } from './announcements-api-routes'

@Injectable({
  providedIn: 'root'
})
export class AnnouncementsService {
  constructor(
    private http: HttpService,
    private tableActionsService: TableActionsService
  ) {}

  sendAnnouncement(payload: ISendAnnouncementRequest) {
    const formData = new FormData()
    formData.append('title', payload.title)
    formData.append('body', payload.body)
    formData.append('deliveryMode', payload.deliveryMode)
    formData.append('sendToAll', `${payload.sendToAll}`)
    if (payload.expirationDate) {
      formData.append('expirationDate', payload.expirationDate)
    }
    payload.recipientIds?.forEach((id) => formData.append('recipientIds', id))
    payload.images?.forEach((image) => formData.append('images', image, image.name))

    return this.http.post(ANNOUNCEMENTS_API_URL.send, formData)
  }

  getMyAnnouncements(): Observable<IAnnouncementsResponse> {
    return this.http.get(ANNOUNCEMENTS_API_URL.mine)
  }

  getUnreadCount(): Observable<IUnreadAnnouncementsCountResponse> {
    return this.http.get(ANNOUNCEMENTS_API_URL.unreadCount)
  }

  markRead(recipientId: string) {
    return this.http.post(ANNOUNCEMENTS_API_URL.markRead(recipientId), {})
  }

  markUnread(recipientId: string) {
    return this.http.post(ANNOUNCEMENTS_API_URL.markUnread(recipientId), {})
  }

  archiveMine(recipientId: string) {
    return this.http.post(ANNOUNCEMENTS_API_URL.archiveMine(recipientId), {})
  }

  unarchiveMine(recipientId: string) {
    return this.http.post(ANNOUNCEMENTS_API_URL.unarchiveMine(recipientId), {})
  }

  deleteMine(recipientId: string) {
    return this.http.delete(ANNOUNCEMENTS_API_URL.deleteMine(recipientId))
  }

  getUsers(): Observable<IAnnouncementUsersResponse> {
    return this.http.get(ANNOUNCEMENTS_API_URL.users)
  }

  getAdminList(info: INew_TableAction): Observable<IAdminAnnouncementsResponse> {
    return this.http.post(
      ANNOUNCEMENTS_API_URL.adminList,
      this.tableActionsService.createRequestPayload(info)
    )
  }

  getAdminDetail(id: string): Observable<IAdminAnnouncementDetail> {
    return this.http.get(ANNOUNCEMENTS_API_URL.adminDetail(id))
  }

  deactivate(id: string) {
    return this.http.post(ANNOUNCEMENTS_API_URL.deactivate(id), {})
  }
}
